const state = {
    boardsActive: false,
    boardsReady: false,
    intervalBoardsTime: 60000,
    intervalChatTime: 6000,
    intervalBoards: false,
    intervalChat: false,
    allMessages: false,
    updating: {
        boards: false,
        messages: false,
    },
    board: {
        bauprojekt: [],
        haus: [],
        wohnung: [],
        kunde: [],
        dienstleister: [],
    }
}

const getters = {
    bauprojekte: (state) => state.board.bauprojekte,
    hauser: (state) => state.board.hauser,
    wohnungen: (state) => state.board.wohnungen,
    kunden: (state) => state.board.kunden,
    dienstleister: (state) => state.board.kunden,
    statusBoards: (state) => state.boardsActive,
    messages: (state) => state.board,
    boardsReady: (state) => state.boardsReady,
    allMessages: (state) => state.allMessages,
    updating: (state) => state.updating
}

const actions = {
    async initBoards({ commit, dispatch }) {        
        await dispatch("updateAllMessages");
        await dispatch("updateBoards");        
        await dispatch("startIntervalBoards");
        commit("setBoardsReady");
        commit("onBoards");
    },
    shutdown({ dispatch, commit }) {
        dispatch("stopIntervalBoards");
        commit("offBoards");
    },
    async startIntervalBoards({ commit, dispatch }) {
        if (state.boardsActive == false) {
            await dispatch("updateBoards");

            let intId = setInterval(async function () {
                await dispatch("updateAllMessages");
                await dispatch("updateBoards");
            }, state.intervalBoardsTime);
            commit("setIntervalBoards", intId);
            commit("setBoardsReady");
        }
    },
    stopIntervalBoards() {
        clearInterval(state.intervalBoards);
    },

    //TODO: test
    async updateAllMessages({ commit }) {
        if (state.updating.messages) return;
        const fields = {
            fields: "*.*.*"
        }
        try {
            commit("setUpdateStateMessages");
            const response = await this._vm.$directus.items("board_messages").readByQuery(fields);
            commit("setAllMessages", response.data);
        } catch (error) {
            console.log(error);
            throw error;
        } finally {
            commit("unsetUpdateStateMessages");
        }
    },
    async updateBoards({ commit, dispatch }) {
        if (state.updating.boards) return;
        try {
            commit("setUpdateStateBoards");
            await dispatch("updateBoard", "bauprojekt");
            await dispatch("updateBoard", "haus");
            await dispatch("updateBoard", "wohnung");
            await dispatch("updateBoard", "kunde");
            await dispatch("updateBoard", "dienstleister");
        } catch (error) {
            console.log(error);
            throw error;
        } finally {
            commit("unsetUpdateStateBoards");
        }
    },
    async updateSomeBoards({ commit, dispatch }, boards) {
        if (state.updating.boards) return;
        try {
            commit("setUpdateStateBoards");
            await dispatch("updateAllMessages");
            for (let idx = 0; idx < boards.length; idx++) {
                await dispatch("updateBoard", boards[idx]);
            }
        } catch (error) {
            console.log(error);
            throw error;
        } finally {
            commit("unsetUpdateStateBoards");
        }
    },

    async updateBoard({ commit }, board) {
        const boardName = "board_messages_" + board;
        try {
            const response = await this._vm.$directus.items(boardName).readByQuery({
                limit: -1,
            });
            commit("setBoardMessages", { board, messages: response.data });
        } catch (error) {
            console.log(error);
            throw error;
        }
    },

    //TODO: test
    async processMessage({ dispatch }, msg) {
        let messageId = null;
        try {
            const response = await this._vm.$directus.items("board_messages").createOne(msg);
 
            if (response != undefined && !response.hasOwnProperty('id')) 
                throw "Malformed response in msg/processMessage";
            messageId = response.id;
            const relationsPayload = { ...msg, id: messageId };
            dispatch("resolveRelations", relationsPayload);
            return response;
        } catch (error) {
            console.log(error);
            throw error;
        }
    },

    //TODO: test
    async updateMessageRecipients({ dispatch }, msg) {
        //delete old relations   
        let boardUpdates = [];
        msg.recipients.forEach(rec => {
            if (boardUpdates.indexOf(rec.context) === -1) boardUpdates.push(rec.context);
        });

        try {
            await this._vm.$directus.items("board_messages")
                .updateOne(msg.id, { recipients: msg.recipients });
            await dispatch("removeBoardRelations", msg);
            await dispatch("resolveRelations", msg);
        } catch (error) {
            throw error;
        }

    },
    async removeBoardRelations({ dispatch }, msg) {
        if (!msg.recipients.length) throw "Error in removeBoardRelations, no recipients found.";
        let boardUpdates = [];

        for (let idx = 0; idx < msg.recipients.length; idx++) {
            if (boardUpdates.indexOf(msg.recipients[idx].context) == -1) boardUpdates.push(msg.recipients[idx].context);
        }
        try {
            await dispatch("deleteFromAllBoards", msg.id);
        } catch (error) {
            throw error;
        }

        if (boardUpdates.length) await dispatch("updateSomeBoards", boardUpdates);
    },

    async deleteFromAllBoards(_, msgId) {
        const boards = Object.keys(state.board).map(board => {
            return "board_messages_" + board;
        });
        for (let i = 0; i < boards.length; i++) {
            try {
                const boardRelation = await this._vm.$directus.items(boards[i]).readByQuery({ filter: { message_id: msgId } });
                if (boardRelation.length) {
                    const toDelete = boardRelation.map(board => board.id);
                    this._vm.$directus.items(boards[i]).deleteMany(toDelete);
                }

            } catch (error) {
                console.log(error);
                throw "Error Deleting Relation Items";
            }
        }
    },
    //TODO: test
    async deleteMessage({ dispatch }, msg) {
        try {
            const search_payload = {
                filter: {
                    message_id: msg.id
                }                
            }
            const bm_kunde = await this._vm.$directus.items("board_messages_kunde").readByQuery(search_payload);
            if (bm_kunde.data.length > 0) {
                bm_kunde.data.forEach(async item => {
                    await this._vm.$directus.items("board_messages_kunde").deleteOne(item.id);
                });
            }

            const bm_wohnung = await this._vm.$directus.items("board_messages_wohnung").readByQuery(search_payload);
            if (bm_wohnung.data.length > 0) {
                bm_wohnung.data.forEach(async item => {
                    await this._vm.$directus.items("board_messages_wohnung").deleteOne(item.id);
                });
            }

            await dispatch("deleteFromAllBoards", msg.id);
            await this._vm.$directus.items("board_messages").deleteOne(msg.id);            
            await dispatch("updateAllMessages");
            await dispatch("updateBoards");
        } catch (error) {
            console.log(error);
            throw error;
        }
    },
    async resolveRelations({ dispatch }, msg) {
        var boardUpdates = [];
        if (!msg.recipients.length) throw "Could not find Recipients in Message";
        for (let index = 0; index < msg.recipients.length; index++) {
            const rec = msg.recipients[index];
            const relationPayload = { message_id: parseInt(msg.id), [rec.context + '_id']: parseInt(rec.id), target: 'board_messages_' + rec.context };
            await dispatch("createBoardRelation", relationPayload);
            if (boardUpdates.indexOf(rec.context) == -1) boardUpdates.push(rec.context);
        }
        if (boardUpdates.length) await dispatch("updateSomeBoards", boardUpdates);
    },

    //TODO: test
    async createBoardRelation(_, payload) {
        const collection = payload.target;
        delete payload.target;
        try {
            await this._vm.$directus.items(collection).createOne(payload);
        } catch (error) {
            console.log(error);
            throw ("Could not Create Relation in msg/createboardRelation");
        }
    },

}

const mutations = {
    onBoards: (state) => {
        state.boardsActive = true;
    },
    offBoards: (state) => {
        state.boardsActive = false;
    },
    setBoardsUpdateActive: (state) => { state.boardsActive = true },
    setBoardsUpdateInactive: (state) => { state.boardsActive = false },
    setIntervalBoards: (state, intervalRef) => state.intervalBoards = intervalRef,
    setBoardMessages: (state, msg) => { state.board[msg.board] = msg.messages },
    setBoardsReady: (state) => { state.boardsReady = true },
    setBoardsNotReady: (state) => { state.boardsReady = false },
    setAllMessages: (state, messages) => { state.allMessages = messages },
    setUpdateStateBoards: (state) => state.updating.boards = true,
    unsetUpdateStateBoards: (state) => state.updating.boards = false,
    setUpdateStateMessages: (state) => state.updating.messages = true,
    unsetUpdateStateMessages: (state) => state.updating.messages = false
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations,
};